import { useSelector } from 'react-redux';
import { RootState } from 'redux/root';
import Account from 'static/models/Account';

export const useTravelProvider = (): Account => {
    return useSelector((state: RootState) => state.travelProvider);
};
